<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
      <div class="sticky top-0 bg-white border-b p-4 md:p-6 flex justify-between items-center">
        <h2 class="text-xl md:text-2xl font-bold text-gray-800">Восстановление пароля</h2>
        <button
          @click="$emit('close')"
          class="text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>
      </div>

      <div class="p-4 md:p-6 space-y-4">
        <p class="text-sm text-gray-600 mb-4">
          Заполните форму ниже. После рассмотрения заявки модератор свяжется с вами для предоставления нового пароля.
        </p>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Логин
          </label>
          <input
            v-model="form.login"
            type="text"
            placeholder="Введите ваш логин"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Email <span class="text-gray-400 font-normal">(необязательно)</span>
          </label>
          <input
            v-model="form.email"
            type="email"
            placeholder="Введите ваш email"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
          />
        </div>

        <div v-if="error" class="bg-red-50 border border-red-200 rounded-lg p-3">
          <p class="text-sm text-red-700">{{ error }}</p>
        </div>

        <div v-if="success" class="bg-green-50 border border-green-200 rounded-lg p-3">
          <p class="text-sm text-green-700">{{ success }}</p>
        </div>
      </div>

      <div class="sticky bottom-0 bg-gray-50 border-t p-4 md:p-6 flex gap-3">
        <button
          @click="$emit('close')"
          class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition font-medium"
          :disabled="loading"
        >
          Отмена
        </button>
        <button
          @click="submitRequest"
          class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium"
        >
          {{ loading ? 'Отправка...' : 'Отправить заявку' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_PASSWORD_RECOVERY } from '@/const/uri';

export default {
  name: 'PasswordRecoveryModal',
  emits: ['close', 'success'],
  data() {
    return {
      form: {
        login: '',
        email: '',
      },
      loading: false,
      error: '',
      success: '',
    };
  },
  computed: {
    isFormValid() {
      return this.form.login.trim();
    },
  },
  methods: {
    async submitRequest() {
      if (!this.isFormValid) {
        this.error = 'Введите логин';
        return;
      }

      this.loading = true;
      this.error = '';
      this.success = '';

      try {
        const data = { login: this.form.login.trim() };
        if (this.form.email.trim()) {
          data.email = this.form.email.trim();
        }
        await axios.post(API_PASSWORD_RECOVERY.create, data);

        this.$emit('success');
        this.$emit('close');

      } catch (err) {
        console.error('Error submitting recovery request:', err);
        const errorData = err.response?.data;

        if (errorData?.errors) {
          const firstError = Object.values(errorData.errors)[0];
          this.error = Array.isArray(firstError) ? firstError[0] : firstError;
        } else if (errorData?.error) {
          this.error = errorData.error;
        } else {
          this.error = 'Ошибка при отправке заявки. Попробуйте позже.';
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
